export default "__VITE_ASSET__CwF6ZHSy__"